import { useMutation } from '@tanstack/react-query';
import { UpdateChartDocPayload, ChartDocData } from '@usacsmideo/types';
import { doc, setDoc } from 'firebase/firestore';
import { db } from '../constants/firebaseModular';
import * as Sentry from '@sentry/browser';
import { APPLICATION_STATUS, createLastUpdated, UPDATE_SOURCE } from '../utilities/updateHelpers';

const updateChartSection = async (payload: UpdateChartDocPayload) => {
  const docTitle = Object.keys(payload.docData)[0];
  const chartDocRef = doc(db, 'users', payload.patientId, 'Chart', docTitle);
  const data = payload.docData[docTitle as keyof ChartDocData];
  let failedWrite: 'chart' | 'userDoc' = 'chart';

  try {
    // UPDATE THE CHART SUBCOLLECTION DOCUMENT
    await setDoc(chartDocRef, data, { merge: true });

    // UPDATE lastUpdated ON THE PARENT USER DOCUMENT
    // A FAILURE HERE STILL FAILS THE SAVE: applicationStatus (E.G. SUBMITTED) LIVES IN THIS WRITE
    failedWrite = 'userDoc';
    const userDocRef = doc(db, 'users', payload.patientId);
    const lastUpdated = createLastUpdated(UPDATE_SOURCE.PORTAL, payload.patientId);
    const applicationStatus = payload.applicationStatus ?? APPLICATION_STATUS.OPEN;
    await setDoc(userDocRef, { lastUpdated, applicationStatus }, { merge: true });
  } catch (error) {
    // REPORT HERE BECAUSE SOME CALLERS HAVE NO onError, THEN RETHROW THE SAME INSTANCE SO THE
    // CALLER'S onError RUNS. RETHROWING A NEW Error WOULD MAKE A CALLER'S OWN CAPTURE A SECOND EVENT.
    Sentry.captureException(error, { tags: { chartDoc: docTitle, chartWrite: failedWrite } });
    throw error;
  }
};

export const useUpdateChartSection = () => {
  return useMutation({
    mutationFn: (payload: UpdateChartDocPayload) => updateChartSection(payload),
  });
};
